import React from 'react';

import { Button } from '@components/common';

import styles from './NotesModal.module.scss';

interface INotesModal {
	note: string;
	closeModal: () => void;
}

const NotesModal = ({
	note,
	closeModal,
}: INotesModal) => {
	return (
		<>
			<p className={styles.note}>
				{note}
			</p>
			<div className={styles.closeButton}>
				<Button
					onClick={closeModal}
					text='Close'
				/>
			</div>
		</>
	);
};

export default NotesModal;
